import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useDepositValidationCart = () => {
  const settingGlobal = useSelector((state) => state.settingGlobalReducer.settingGlobal);

  return useMemo(() => settingGlobal?.DepositValidationCart ?? true, [settingGlobal]);
};
